export default __webpack_public_path__ + "static/media/Customers.a0a6eb14.svg";